export const formatCurrency = (value: number): string => {
  return `R$ ${value.toFixed(2)}`;
};
